import { css, html } from 'lit';
import { AnimationHelper } from '../modules/animation_helper';
import { KryptonConstants } from '../modules/krypton_constants';
import { KryptonElement } from './krypton-element';
import { SlideElement } from './slider-element';

export class SliderCanvas extends KryptonElement {

    static finalizeStyles(styles?: any) {
        return [
            styles ? styles : css``,
            css`
                ::slotted(slider-element){
                    display:none;
                }
                ::slotted(slider-element[open]){
                    display:block;
                }
            `
        ];
    };

    render() {
        return html`
            <div id="slide-container">
                <slot @slotchange="${this.onSlotChange}"></slot>
            </div>
        `;
    }

    constructor() {
        super();
        this.direction = "vertical"; //TODO this may not trigger a change event in IE
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    get slideContainer() {
        return this.shadowRoot?.getElementById("slide-container");
    }

    get slides(): SlideElement[] {
        return [].slice.call(this.querySelectorAll("slider-element")) || [];
    }

    get currentSlide(): SlideElement {
        let slide = this.querySelector("slider-element[open]");
        let hash = location.hash?.toString();
        let pos = hash.lastIndexOf("#");
        if (pos) {
            hash = hash.substring(pos);
        }
        if (!slide && hash && !hash.substring(1).match(KryptonConstants.servletNameRegex))
            slide = this.querySelector(hash);
        if (!slide)
            slide = this.slides[0];
        return slide as SlideElement;
    }

    onSlotChange(e: Event) {

        this.slideContainer?.style.setProperty("scroll-behavior", "auto", "important");

        const elements = this.shadowRoot?.querySelector("slot")?.assignedNodes().filter(n => n instanceof SlideElement); //use assignedNodes because IE doesn't support assignedElements

        if (!elements)
            return;

        const slides = elements.filter(n => n instanceof SlideElement) as SlideElement[];

        let firstSlide = this.currentSlide;
        firstSlide.open = true;
        slides.forEach(slide => {
            slide.id = slide.getAttribute("name") || '';
            slide.open = slide == firstSlide;
        });

        this.requestUpdate();
    }

    doNavigateToSlide(targetSlideSelector: any) {
        location.replace(targetSlideSelector); //TODO check that this works in IE

        const targetSlide: SlideElement = this.querySelector(targetSlideSelector);
        if (!targetSlide)
            return;
        AnimationHelper.getAnimationHelper(this._direction).animateNavigateToSlide(targetSlide, this.currentSlide);
    }

    doNavigateSlideBack(targetSlide: any) {
        AnimationHelper.getAnimationHelper(this._direction).animateNavigateBackToSlide(this.querySelector(targetSlide), this.currentSlide);
    }

    createNewSliderElement(details: any, addElement: any) {//Create new slider element which will be appended to the slider-canvas later
        const div = document.createElement("div");
        if (addElement) {
            div.appendChild(addElement);
        }
        div.setAttribute("id", details.sliderName + "-div")
        const sliderElement = document.createElement("slider-element");
        sliderElement.setAttribute("id", details.sliderName);
        sliderElement.setAttribute("name", details.sliderName);
        sliderElement.setAttribute("created", "true");
        sliderElement.appendChild(div);
        return sliderElement;
    }

    private _direction = "vertical";
    get direction() {
        return this._direction;
    }

    set direction(direction) {
        const oldValue = this._direction;
        this._direction = direction;
        this.requestUpdate("direction", oldValue);
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'slider-canvas': SliderCanvas;
    }
}
